// export const API_BASE = 'http://localhost:8000'.replace(/\/$/, '');
export const API_BASE = 'https://bendev.globaldevpros.com'.replace(/\/$/, '');
// const API_BASE = 'https://signlcrm.com'.replace(/\/$/, '');

const getCookie = (name) => {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? decodeURIComponent(match[2]) : null;
};

export const apiFetch = async (endpoint, options = {}) => {
  const token = localStorage.getItem("token"); // legacy fallback; prefer HttpOnly cookie
  const csrfToken = getCookie('csrf_token');
  const body = options.body;
  const isFormData = typeof FormData !== 'undefined' && body instanceof FormData;
  const isUrlEncoded = typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams;

  const headers = {
    ...(token && { Authorization: `Bearer ${token}` }),
    ...(csrfToken ? { 'X-CSRF-Token': csrfToken } : {}),
    ...(!isFormData && !isUrlEncoded ? { 'Content-Type': 'application/json' } : {}),
    ...options.headers,
  };

  // Handle queryParams
  let queryString = "";
  if (options.queryParams) {
    const params = new URLSearchParams(options.queryParams).toString();
    queryString = `&${params}`;
  }

  const url = `${API_BASE}/api/api.php?action=${endpoint}${queryString}`;

  const res = await fetch(url, {
    ...options,
    headers,
    credentials: 'include',
  });

  const raw = await res.text();
  let data;
  try {
    data = raw ? JSON.parse(raw) : {};
  } catch (parseErr) {
    throw new Error(raw || 'Invalid server response');
  }

  if (
    res.status === 401 ||
    data?.message === 'Invalid token' ||
    data?.message === 'Unauthorized'
  ) {
    localStorage.removeItem("token");
    localStorage.removeItem("loggedInUser");
    // Redirect users back to login so they can re-authenticate
    if (typeof window !== "undefined") {
      window.location.href = "/login";
    }
    throw new Error("Session expired. Please log in again.");
  }

  if (!res.ok || data.success === false) {
    throw new Error(data.message || 'API request failed');
  }
  return data;
};
